module.exports = "/assets/site/images/hornyak_tamas.jpg?526a97af8ede1c874f016ae34cfc5574";